import { combineReducers } from 'redux'
import { history } from 'js/redux/middleware/history'
import { connectRouter } from 'connected-react-router'
import auth from './auth'
import dashboard from './dashboard'
import explorer from './explorer'
import map from './map'
import notes from './notes'
import report from './report'
import search from './search'
import general from './general'

export default combineReducers({
  auth,
  dashboard,
  explorer,
  map,
  notes,
  report,
  search,
  general,
  router: connectRouter(history)
})
